import { BUILDING_OBJECT_TYPE_ABBREVIATIONS } from 'shared/constants/buildingLabels';
import type { TBuildingObjectType } from 'shared/types/buildingCard';
import type { TOffersDealType } from 'shared/types/buildingOffers';

/** «В этом ТЦ пока нет предложений на продажу» (`serp_subscribe_panel.tsx` монолита); нештатный тип — как БЦ */
export const getOffersEmptyTitle = (type: TBuildingObjectType | null, dealType: TOffersDealType): string =>
  `В этом ${BUILDING_OBJECT_TYPE_ABBREVIATIONS[type ?? 'businessCenter']} пока нет предложений ${dealType === 'rent' ? 'в аренду' : 'на продажу'}`;
